(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coconix-shipping-bar"]) return;
  try {
    
  if (!customElements.get('coconix-shipping-bar')) {
    class CoconixShippingBar extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.messageElement = this.querySelector('[data-shipping-message]');
        this.liveElement = this.querySelector('[data-shipping-live]');
        this.progressElement = this.querySelector('[data-shipping-progress]');
        this.lastMessage = this.dataset.initialMessage || '';
        this.refreshTimer = null;
        this.handleCartChange = (event) => {
          if (event.detail && event.detail.cart) {
            this.render(event.detail.cart);
          } else {
            this.queueRefresh();
          }
        };
        this.handlePageShow = () => this.queueRefresh();
        document.addEventListener('theme:cart:change', this.handleCartChange);
        document.addEventListener('theme:cart:reload', this.handleCartChange);
        document.addEventListener('cart:updated', this.handleCartChange);
        window.addEventListener('pageshow', this.handlePageShow);
        const cartCount = document.querySelector('[data-cart-count]');
        if (cartCount) {
          this.cartObserver = new MutationObserver(() => this.queueRefresh());
          this.cartObserver.observe(cartCount, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
          });
        }
        this.refresh();
      }

      disconnectedCallback() {
        document.removeEventListener('theme:cart:change', this.handleCartChange);
        document.removeEventListener('theme:cart:reload', this.handleCartChange);
        document.removeEventListener('cart:updated', this.handleCartChange);
        window.removeEventListener('pageshow', this.handlePageShow);
        if (this.cartObserver) this.cartObserver.disconnect();
        if (this.refreshTimer) window.clearTimeout(this.refreshTimer);
      }

      queueRefresh() {
        if (this.refreshTimer) window.clearTimeout(this.refreshTimer);
        this.refreshTimer = window.setTimeout(() => this.refresh(), 120);
      }

      refresh() {
        window
          .fetch(this.dataset.cartUrl, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          })
          .then((response) => {
            if (!response.ok) throw new Error('Cart request failed');
            return response.json();
          })
          .then((cart) => this.render(cart))
          .catch(() => {});
      }

      isEligibleCountry() {
        const countries = (this.dataset.countryCodes || '')
          .split(',')
          .map((code) => code.trim().toUpperCase())
          .filter(Boolean);
        return countries.length === 0 || countries.includes((this.dataset.country || '').toUpperCase());
      }

      formatMoney(cents, currency) {
        const locale = document.documentElement.lang || 'en-US';
        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
            maximumFractionDigits: cents % 100 === 0 ? 0 : 2
          }).format(cents / 100);
        } catch (error) {
          return `$${(cents / 100).toFixed(cents % 100 === 0 ? 0 : 2)}`;
        }
      }

      withAmount(template, amount) {
        return (template || '').replace('[amount]', amount);
      }

      render(cart) {
        if (!this.isEligibleCountry()) {
          this.hidden = true;
          return;
        }

        this.hidden = false;
        const mode = this.dataset.displayMode;
        const baseThreshold = Number(this.dataset.thresholdBaseCents) || 0;
        const currencyRate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
        const threshold = Math.round(baseThreshold * currencyRate);
        const total = Number(cart.total_price) || 0;
        const currency = cart.currency || this.dataset.currency || 'USD';
        let message = this.dataset.simpleMessage || '';
        let progress = 100;

        if (mode === 'threshold' && threshold > 0) {
          if (total <= 0) {
            message = this.withAmount(
              this.dataset.emptyMessage,
              this.formatMoney(threshold, currency)
            );
            progress = 0;
          } else if (total >= threshold) {
            message = this.dataset.successMessage || '';
            progress = 100;
          } else {
            const remaining = threshold - total;
            message = this.withAmount(
              this.dataset.progressMessage,
              this.formatMoney(remaining, currency)
            );
            progress = Math.min(100, Math.max(0, (total / threshold) * 100));
          }
        }

        if (this.messageElement) this.messageElement.textContent = message;
        if (this.progressElement) {
          this.style.setProperty('--cx-shipping-progress', `${progress}%`);
        }
        if (this.liveElement && this.lastMessage && this.lastMessage !== message) {
          this.liveElement.textContent = message;
        }
        this.lastMessage = message;
      }
    }

    customElements.define('coconix-shipping-bar', CoconixShippingBar);
  }

  } catch(e) { console.error(e); }
})();
})();
